Drupal.behaviors.labelFloat = {
	attach: function(context, settings) {
		function removeLabel(selector, css) {
			let inputCollection = document.querySelectorAll(selector);

			function setClass(arg1, arg2) {
				if (arg1.value != undefined) {
					if (arg1.value.length > 0) {
						arg1.parentNode.classList.add(arg2);
					} else {
						arg1.parentNode.classList.remove(arg2);
					}
				}
			}

			inputCollection.forEach(_input => {
				let input = _input,
				inputValue = input.value;

				setClass(input, css);

				input.addEventListener("keyup", _logKey => {
					setClass(input, css);
				});
			})
		}

		removeLabel('.js-form-type-textfield input', 'label-floated');
		removeLabel('.js-form-type-email input', 'label-floated');
	}
};

/*
document.addEventListener('DOMContentLoaded', function() {


});
*/
